import React from 'react';

class About extends React.Component{
    render() {
        return (
            <div id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6"> <img src="img/about.jpg" className="img-fluid" alt=""/> </div>
                        <div className="col-12 col-md-6">
                            <div className="about-text">
                                <h2>About Us</h2>
                                <p>{this.props.data ? this.props.data.paragraph : 'loading...'}</p>
                                <h3>What We Offer:</h3>
                                <div className="d-lg-flex d-md-flex">
                                    <div className="col-xl-6 col-lg-6 col-sm-6 col-md-6 col-12">
                                        <ul>
                                            {this.props.data ? this.props.data.Why.map((d, i) => <li  key={`${d}-${i}`}>{d}</li>) : 'loading'}
                                        </ul>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-sm-6 col-md-6 col-12">
                                        <ul>
                                            {this.props.data ? this.props.data.Why2.map((d, i) => <li  key={`${d}-${i}`}> {d}</li>) : 'loading'}

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default About;